import { GoogleLogin } from "@react-oauth/google";
import { useGoogleLogin as useServerGoogleLogin } from "../../api/auth";
import { notifications } from "@mantine/notifications";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { applySignInResponse } from "../../services/authStore";
import { AuthContext } from "../../services/context";

export function GoogleButton() {
  const navigate = useNavigate();
  const { setUser } = useContext(AuthContext);

  const { mutate } = useServerGoogleLogin();

  return (
    <GoogleLogin
      shape="pill"
      locale="en"
      logo_alignment="center"
      onSuccess={(credentialResponse) => {
        mutate(
          {
            token: credentialResponse,
          },
          {
            onSuccess: (data) => {
              applySignInResponse(data);
              setUser({ ...data.user, picture: data.user.picture });
              navigate("/app");
            },
            // The error notification is shown by useApiMutation, using the
            // message from the API (no account / no email / try again).
            onError: (error) => {
              console.error("Google login failed:", error);
            },
          }
        );
      }}
      onError={(error) => {
        console.error("Google login failed:", error);
        notifications.show({
          title: "Google login failed",
          message: "Please try again.",
          color: "red",
        });
      }}
    />
  );
}
